const route = {
    login: '/login',
    masterroutes: '/masterroutes',
    masterrepo: '/masterrepo',
    masterlanguages: '/masterlanguages',
    liveproducts: '/liveproducts',
    rateproducts: '/rateproducts',
    commodity: '/commodity',
    subcommodity: '/subcommodity',
    news: '/news',
    updates: '/Updates',
    spots: '/spots',
    addupdate: '/addupdate',
    editupdate: '/editupdate/:updateid',
    addspot: '/addspot',
    editspot: '/editspot/:spotid',
    editnews: '/editnews/:newsid',
    settings: '/settings',

    departments: '/departments',
    specialities: '/specialities',
    events: '/events',
    participants: '/participants',
    orderdetails: '/orderdetails/:id',
    editproduct: '/editproduct/:id',
    editstoreproduct: '/editstoreproduct/:id',
    addstoreproduct: '/addstoreproduct',
    managefeedback : '/feedback',
    addproduct: '/addproduct',
    editbroker: '/editbroker/:id',
    addbroker: '/addbroker',
    manageroleaccess: '/manageroleaccess',
    editpermissions: '/editpermissions',

    
    masterroles: '/masterroles',
    backofficeusers: '/backofficeusers',
    survey: '/survey',
    brokers: '/brokers',
    products: '/products',
    mastercommodity: '/mastercommodity',

    editsubcommodity: '/editsubcommodity/:id',
    addsubcommodity: '/addsubcommodity',

    editcommodity: '/editcommodity/:id',
    addcommodity: '/addcommodity',

    addnews: '/addnews',

    addstoreprice: '/editstoreprice/:rateid',
    buyselldashboard: '/buyselldashboard',
    editstoreprice: '/editstoreprice/:rateid/:viewtype',
    editmastercommodity: '/editmastercommodity/:id',
    addmastercommodity: '/addmastercommodity',
    editbuysell: '/editbuysell/:type/:id',
    addbuysell: '/addbuysell/:type',

    livesummary: '/livesummary/:productid',
    manageads: '/manageads',
    livelist: '/livelist',
    userslist: '/userslist',
    visitors: '/visitors',
    stallBookings: '/stall-bookings',
    printSticker: '/print-sticker',
    managerates: '/managerates',
    managebuy: '/managebuy/:type',
    managesell: '/managesell',
    edituser: '/edituser/:userid',
    dashboard: '/dashboard',
    profile: '/profile',
    eventlist: '/eventlist',
    productupload: '/createevent',
    configuration: '/Configuration',
    vendor: '/vendorlist',
    productlist: '/productlist',
    orderlist: '/orderlist',
    materiallist: '/material',
    producttypes: '/producttypes',
    voucherdiscount: '/voucherdiscount',
    priceupdate: '/priceupdate',
    productAttributes: '/product_attributes',
    diamondDetails: '/diamond_details',
    gemstoneDetails:'/gemstone-details',
    variants:'/variants',
    images:'/images',
    createVariant:'/create_variant',
    materiallistpage:'/newmaterial',
    editCategory:'/editcategory',
    dummyscreen:'/dummyscreen',


    /****** Buy Sell */
    masterquantity:'/masterquantity',

    /****** Survey Group */

    editsurvey: '/editsurvey',
    editquantity: '/editquantity',
    editad: '/editad',
    // editad: '/editad/:id',

}

export default route;